import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const TOKEN_KEY = "smsc_token";

export default function ProtectedRoute({ children }) {
  const { token, loading } = useAuth();

  if (loading) {
    return (
      <p className="text-gold text-center py-20 font-heading text-2xl">Loading...</p>
    );
  }

  // Check both React state and sessionStorage (state may lag after login)
  const hasToken = token || sessionStorage.getItem(TOKEN_KEY);

  if (!hasToken) {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
}
